/** /admin/api/templates のレスポンス1件分 */
export interface TemplateItem {
  id: number
  name: string
  page_type: number
  body_html: string
  sort_order: number
}

/**
 * 画像フィールドが取りうる値。
 * File[] = 新規アップロード / string = 保存済みURL / '' = クリア
 */
export type ImageFieldValue = File[] | string | null | undefined

export interface PageGroupPayload {
  pageGroup: Record<string, any>
  keyVisual: File | string
  logo: File | string
  incentiveImage: File | string
  incentiveImageGuest: File | string
}

/** 画像フィールドを API に渡す形へ変換する。保存済みURLは文字列のまま送り返して既存画像を維持し、クリア時は空文字を送る */
export function extractImageParam(value: ImageFieldValue): File | string {
  if (!value) return ''
  if (!value[0]) return ''
  return typeof value[0] === 'string' ? (value as string) : (value[0] as File)
}

/**
 * 選択されたテンプレートの本文を解決する。
 * 一致するテンプレートがなければフォームが持つ bodyHtml をそのまま使う
 */
export function resolveBodyHtml(values: any, templates: TemplateItem[] | undefined): string {
  const matched = (templates ?? []).find((t) => t.id === values.template_type)
  return matched ? matched.body_html : values.bodyHtml
}

/** フォームの値から page_group 更新用のペイロードを組み立てる。name / analytics_html / 画像カラムはサーバ側が決めるため含めない */
export function buildPageGroupPayload(
  values: any,
  templates: TemplateItem[] | undefined
): PageGroupPayload {
  return {
    pageGroup: {
      page_description: values.pageDescription,
      enabled: values.enabled,
      body_html: resolveBodyHtml(values, templates),
      start_date: values.startDate,
      end_date: values.endDate,
      enable_web_cv: values.enable_web_cv,
      enable_coming_cv: values.enable_coming_cv,
      key_visual_text: values.key_visual_text,
      link_text: values.link_text,
      link_url: values.link_url,
      flow_text: values.flow_text,
      notice: values.notice,
      terms: values.terms,
      privacy_policy: values.privacy_policy,
      tag: values.tag,
      template_type: values.template_type,
      incentive_action: values.incentive_action,
      incentive_content: values.incentive_content,
      incentive_amount: values.incentive_amount,
      incentive_content_guest: values.incentive_content_guest,
      incentive_amount_guest: values.incentive_amount_guest,
      theme_color: values.theme_color,
      button_color: values.button_color,
      guest_limit: values.guest_limit,
    },
    keyVisual: extractImageParam(values.key_visual),
    logo: extractImageParam(values.logo),
    incentiveImage: extractImageParam(values.incentive_image),
    incentiveImageGuest: extractImageParam(values.incentive_image_guest),
  }
}
